import React from "react";
import { Button } from "@shared/components/Common";

const FileZoneUploadButton = () => {
  return <Button className="import-patients-btn outline-blue">Browse</Button>;
};

export default FileZoneUploadButton;
